// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sign-up-page {
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  box-sizing: border-box;
  overflow: hidden;
  background: radial-gradient(circle at 12% 6%, rgba(22, 119, 255, 0.14), transparent 36%), radial-gradient(circle at 88% 4%, rgba(90, 178, 255, 0.14), transparent 40%), linear-gradient(165deg, #f6faff 0%, #edf4ff 55%, #f9fbff 100%);
  border-radius: 24px;
}

.sign-up-page::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 0;
  border-radius: inherit;
  background: inherit;
}

.sign-up-page__panel {
  position: relative;
  z-index: 1;
  width: min(860px, 100%);
  overflow: hidden;
  border: 1px solid #d6e4ff;
  border-radius: 22px;
  background: #ffffff;
  box-shadow: 0 24px 52px rgba(15, 23, 42, 0.16);
  padding: 28px;
}

.sign-up-page__lang {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 14px;
}

.sign-up-page__header {
  margin-bottom: 18px;
}

.sign-up-page__eyebrow {
  margin: 0 0 6px;
  color: #4f6f9b;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.sign-up-page__title {
  margin: 0;
  color: #111827;
  font-size: 34px;
  line-height: 1.15;
}

@media screen and (max-width: 767px) {
  .sign-up-page {
    min-height: 100vh;
    padding: 20px 10px 28px;
  }
  .sign-up-page__panel {
    padding: 20px 14px;
    border-radius: 18px;
  }
  .sign-up-page__title {
    font-size: 28px;
  }
}
@media screen and (max-width: 575px) {
  .sign-up-page {
    padding: 16px 8px 24px;
  }
  .sign-up-page__panel {
    padding: 18px 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/signUpPage/SignUpPage.sass"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,sOAAA;EACA,mBAAA;AACF;;AACA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,sBAAA;EACA,mBAAA;AAEF;;AAAA;EACE,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,8CAAA;EACA,aAAA;AAGF;;AADA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AAIF;;AAFA;EACE,mBAAA;AAKF;;AAHA;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;AAMF;;AAJA;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAOF;;AALA;EACE;IACE,iBAAA;IACA,uBAAA;EAQF;EANA;IACE,kBAAA;IACA,mBAAA;EAQF;EANA;IACE,eAAA;EAQF;AACF;AAPA;EACE;IACE,sBAAA;EASF;EAPA;IACE,kBAAA;EASF;AACF","sourcesContent":[".sign-up-page\n  position: relative\n  width: 100%\n  min-height: 100vh\n  display: flex\n  align-items: center\n  justify-content: center\n  padding: 32px 16px\n  box-sizing: border-box\n  overflow: hidden\n  background: radial-gradient(circle at 12% 6%, rgba(22, 119, 255, 0.14), transparent 36%), radial-gradient(circle at 88% 4%, rgba(90, 178, 255, 0.14), transparent 40%), linear-gradient(165deg, #f6faff 0%, #edf4ff 55%, #f9fbff 100%)\n  border-radius: 24px\n\n.sign-up-page::before\n  content: \"\"\n  position: absolute\n  inset: 0\n  z-index: 0\n  border-radius: inherit\n  background: inherit\n\n.sign-up-page__panel\n  position: relative\n  z-index: 1\n  width: min(860px, 100%)\n  overflow: hidden\n  border: 1px solid #d6e4ff\n  border-radius: 22px\n  background: #ffffff\n  box-shadow: 0 24px 52px rgba(15, 23, 42, 0.16)\n  padding: 28px\n\n.sign-up-page__lang\n  display: flex\n  justify-content: flex-end\n  margin-bottom: 14px\n\n.sign-up-page__header\n  margin-bottom: 18px\n\n.sign-up-page__eyebrow\n  margin: 0 0 6px\n  color: #4f6f9b\n  font-size: 12px\n  font-weight: 700\n  letter-spacing: 0.1em\n  text-transform: uppercase\n\n.sign-up-page__title\n  margin: 0\n  color: #111827\n  font-size: 34px\n  line-height: 1.15\n\n@media screen and (max-width: 767px)\n  .sign-up-page\n    min-height: 100vh\n    padding: 20px 10px 28px\n\n  .sign-up-page__panel\n    padding: 20px 14px\n    border-radius: 18px\n\n  .sign-up-page__title\n    font-size: 28px\n\n@media screen and (max-width: 575px)\n  .sign-up-page\n    padding: 16px 8px 24px\n\n  .sign-up-page__panel\n    padding: 18px 12px\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
